const getEnv = () => {
    const hostName = window.location.hostname; // NOSONAR
    if (hostName.includes('localhost')) {
        return 'local';
    }
    if (hostName.includes('dev.fordpowersense.com') || hostName.includes('dev.fordpowersense')) {
        return 'qa';
    }
    return 'prod'; // Default to prod for any other domain
};

const getBaseUrl = () => {
    const env = getEnv();
    switch (env) {
        case 'local':
        case 'qa':
            return 'https://dev-api.fordpowersense.com';
        case 'prod':
            return 'https://api.fordpowersense.com';
        default:
            return 'https://dev-api.fordpowersense.com';
    }
};

const AzureKeysForLocal = {
    REACT_APP_AZURE_CLIENT_ID: '13a70f5e-3994-471b-ba64-d742d309aa5a',
    REACT_APP_AZURE_AUTHORITY: 'https://login.microsoftonline.com/1ac10925-d44b-4c83-9cd8-e41079055464',
    REACT_APP_REDIRECT_URI: 'http://localhost:3000/login',
    REACT_APP_POST_LOGOUT_REDIRECT_URI: 'http://localhost:3000',
    REACT_APP_AZURE_TENANT_ID: '1ac10925-d44b-4c83-9cd8-e41079055464'
}

const AzureKeysForQA = {
    REACT_APP_AZURE_CLIENT_ID: '13a70f5e-3994-471b-ba64-d742d309aa5a',
    REACT_APP_AZURE_AUTHORITY: 'https://login.microsoftonline.com/1ac10925-d44b-4c83-9cd8-e41079055464',
    REACT_APP_REDIRECT_URI: 'https://dev.fordpowersense.com/login',
    REACT_APP_POST_LOGOUT_REDIRECT_URI: 'https://dev.fordpowersense.com',
    REACT_APP_AZURE_TENANT_ID: '1ac10925-d44b-4c83-9cd8-e41079055464'
}

const AzureKeysForPROD = {
    REACT_APP_AZURE_CLIENT_ID: '13a70f5e-3994-471b-ba64-d742d309aa5a',
    REACT_APP_AZURE_AUTHORITY: 'https://login.microsoftonline.com/1ac10925-d44b-4c83-9cd8-e41079055464',
    REACT_APP_REDIRECT_URI: 'https://fordpowersense.com/login',
    REACT_APP_POST_LOGOUT_REDIRECT_URI: 'https://fordpowersense.com',
    REACT_APP_AZURE_TENANT_ID: '1ac10925-d44b-4c83-9cd8-e41079055464'
}

export const APIUrls = {
    BASE_URL: getBaseUrl(),
    DASHBOARD_ENDPOINTS: {
        GET_SITES: '/devices/sites',
        GET_DEVICES: '/devices', // You can specify the second API endpoint here
        GET_DEVICE_BY_ID: '/devices', // GET /devices/{plug_id}
        GET_LOGS: '/logs', // GET /logs/{plug_id}
        GET_ALERTS: '/alerts'
    },

    OUTAGE_ENDPOINTS: {
        GET_OUTAGE_DEVICES: '/outage/devices',
        GET_OFFLINE_EVENTS: 'outage/report',
        GET_OUTAGE_COUNT: '/outage/number-of-days',
        EXPORT_DEVICES_REPORT: '/outage/devices/report',
    },

    CONFIGURATION_ENDPOINTS: {
        FILE_UPLOAD: '/configuration/upload',
        DEVICES: '/api/devices',    // API Added but not used
        GET_DEVICE_DETAILS_BY_DEVICE_MAC: '/configuration/device/details',
        HISTORY: '/configuration/devices',
        UPDATE_DEVICE: '/configuration/device/update',
        JOB_STATUS: '/configuration/devices/jobs',
    },
    DEIVCE_TROUBLE_SHOOTING: {
      REBOOT: '/api/shelly/reboot',
      TURN_ON: '/api/shelly/on',
      TURN_OFF: '/api/shelly/off',
      GET_HISTORY: '/api/shelly/history'
    },

    DEVICE_MANAGEMENT_ENDPOINTS: {
        SEARCH_DEVICE: '/device/manage/device/details',
        TOGGLE_DEVICE_STATUS: '/device/manage/toggle',
        GET_DISABLED_DEVICES: '/device/manage',
        GET_AVAILABLE_ACTIONS: '/device/manage/status',
        GET_DEVICE_HISTORY: '/device/manage/history'
    }

}


// Export Azure keys based on environment
const getAzureKeys = () => {
    const env = getEnv();
    switch (env) {
        case 'local':
            return AzureKeysForLocal;
        case 'qa':
            return AzureKeysForQA;
        case 'prod':
            return AzureKeysForPROD;
        default:
            return AzureKeysForPROD; // Default to prod
    }
};

export const AZUREKEYS = getAzureKeys();

// Export getEnv function for environment detection
export { getEnv };

export const AppLabels = {
    notApplicable: 'N/A',
    outageLabels: {
        // Page Title and Description
        pageTitle: 'Outage Report',
        pageDescription: 'Outage details (default last 7 days). Choose a date range and search for outage summary details.',
        
        // Loading Messages
        loadingSitesAndLocations: 'Loading sites and locations...',
        loadingDevices: 'Loading devices...',
        
        // Error Messages
        errorPrefix: 'Error: ',
        failedToLoadSites: 'Failed to load sites and locations',
        failedToLoadDevices: 'Failed to load outage devices',
        failedToSearchDevices: 'Failed to search outage devices',
        
        // Filter Labels
        siteLabel: 'Site',
        locationLabel: 'Location',
        socketLabel: 'Socket',
        startDateLabel: 'Start Date',
        endDateLabel: 'End Date',
        
        // Filter Options
        allSites: 'All Sites',
        allLocations: 'All Locations',
        allSockets: 'All Sockets',
        unknownStore: 'Unknown Store',
        
        // Button Labels
        search: 'Search',
        searching: 'Searching...',
        downloadCSV: 'Download CSV',
        
        // KPI Labels
        totalOutageMinutes: 'PDU / Shelly Plug Total Outage',
        devicesCount: 'Devices',
        activeDevices: 'Active Devices',
        
        // Date Range
        rangePrefix: 'Range: ',
        rangeArrow: ' → ',
        
        // Device Status
        online: 'online',
        offline: 'offline',
        unknown: 'Unknown',
        
        // CSV Export
        csvFilenamePrefix: 'Outage_Summary_',
        csvFilenameSuffix: '.csv',
        
        // Table Labels
        outageDetailsTitle: 'Outage Details',
        devicesLabel: 'devices',
        noDevicesFound: 'No devices found for current filters.',
        
        // Miscellaneous
        modem: 'Modem',
        pdu: 'PDU'
    },
    
    offlineEventsLabels: {
        // Drawer Title
        drawerTitle: 'Device Details ',
        
        previousButton: 'Previous',
        nextButton: 'Next',

        // Device Details Labels
        plugIdLabel: 'Plug ID',
        deviceNameLabel: 'Device Name',
        siteLabel: 'Site',
        locationLabel: 'Location',
        deviceMacLabel: 'Device Mac ID',
        statusLabel: 'Status',
        modelLabel: 'Model',
        smartPlugLocationLabel: 'Smart Plug Location',
        criticalDeviceLabel: 'Critical Device',
        singleSourceDevicesLabel: 'Single Power Source Devices',
        dualSourceDevicesLabel: 'Dual Power Source Devices',
        modemIdLabel: 'Modem ID',
        outageLabel: 'Outage ',
        offlineEventsLabel: 'Offline Events',
        
        // Error Messages
        errorLoadingPrefix: 'Error loading offline events: ',
        failedToLoadEvents: 'Failed to load offline events',
        
        // Empty State
        noOfflineEventsFound: 'No Offline Events Found',
        noOfflineEventsDescription: 'This device has no recorded offline events for the selected time period.',
        noRecordedEvents: 'This device has no recorded offline events.',
        
        // Table Headers
        offlineTimeHeader: 'Offline Time',
        onlineTimeHeader: 'Online Time',
        statusHeader: 'Status',
        durationHeader: 'Duration',
        
        // Panel Title
        offlineEventsDetails: 'Offline Events Details',
        eventsCount: 'events',
        
        // Button Labels
        downloadExcel: 'Export',
        closeDrawer: 'Close',
        
        // Excel Export
        excelSerialNumber: 'S.No',
        excelOfflineTime: 'Offline Time',
        excelOnlineTime: 'Online Time',
        excelStatus: 'Status',
        excelDuration: 'Duration (days hours min sec)',
        excelSheetName: 'Offline Events',
        excelFilenamePrefix: 'offline_events_',
        
        // Pagination
        showingText: 'Showing',
        ofText: 'of',
        
        // Device Types
        modem: 'Modem',
        pdu: 'PDU',
        
        // Duration Unit
        minutesSuffix: ' min'
    },
    
    configurationLabels: {
        // Page Title and Mode Buttons
        pageTitle: 'Configuration',
        bulkUploadMode: 'Bulk Upload',
        manualUpdateMode: 'Update ShellyPlug',
        
        // Bulk Upload Section
        bulkUploadTitle: 'Bulk Upload',
        bulkUploadDescription: 'Upload an Excel (.xlsx) file to add/update multiple ShellyPlug records.',
        uploadExcelButton: 'Upload Excel',
        downloadTemplateButton: 'Download Template',
        expectedColumnsLabel: 'Expected columns:',
        
        // Manual Update Section
        manualUpdateTitle: 'Manual Update / Replace',
        enterDeviceMacLabel: 'Enter Device Mac ID',
        loadButton: 'Load',
        loadedExistingRecord: '✓ Loaded existing record.',
        deviceMacNotFound: '⚠ Device Mac ID not found.',
        deviceDetailsHeader: 'Device Details',
        enableReplaceLabel: 'Enable For Replace The Device Mac ID',
        replaceDeviceMacLabel: 'Replace Device Mac ID',
        replaceDeviceMacPlaceholder: 'Enter Device Mac ID',
        updateButton: 'Update',
        createButton: 'Create',
        resetButton: 'Reset',
        
        // Form Field Labels
        storePlugIdLabel: 'Store Plug ID',
        deviceMacLabel: 'Device Mac ID',
        storeNameLabel: 'Store Name',
        locationNameLabel: 'Location Name',
        modelLabel: 'Model',
        autoGeneratedPlaceholder: 'Auto-generated ID',
        smartPlugLocation: 'Smart Plug Location',
        criticalDevices: 'Single Power Source Devices',
        dualCriticalDevices: 'Dual Power Source Devices',
        deviceNameLabel: 'Device Name',
        // History Section
        uploadHistoryTitle: 'Upload History',
        loadingHistory: 'Loading history...',
        noUploadHistory: 'No upload history found',
        
        // Loading and Status Messages
        loadingSitesData: 'Loading sites data...',
        loadingMessage: 'Loading...',
        
        // Error Messages
        failedToLoadSites: 'Failed to load sites data. Please refresh the page to try again.',
        invalidFileFormat: 'Invalid file format. Please upload an Excel (.xlsx) file only.',
        fileSizeTooLarge: 'File size too large. Please upload a file smaller than 1$MB.',
        fileRowLimitExceeded: 'File contains too many rows. Only 1$ rows are allowed. Please reduce the number of rows and try again.',
        fileEmptyOrCorrupted: 'The Excel file appears to be empty or corrupted. Please check your file.',
        fileEmpty: 'The Excel file is empty. Please add data and try again.',
        fileNoData: 'The Excel file must contain at least a header row and one data row.',
        downloadTemplateFailed: 'Failed to download template. Please try again.',
        
        // Validation Messages
        validationErrorsFound: 'Found validation errors',
        allValidationErrors: 'All validation errors:',
        requiredFieldEmpty: 'is required but empty',
        duplicateDeviceMac: 'Duplicate device_mac found',
        invalidDeviceMacFormat: 'Invalid device_mac format',
        
        // Template Info
        templateFilename: 'ShellyPlug_Template.xlsx',
        templateSheetName: 'Template',
        
        // Job Status Dialog
        jobStatusTitle: 'File Status Report',
        jobIdText: 'Job Id',
        jobStatusLoadingText: 'Loading...',
        checkingJobStatusText: 'Checking job status...',
        checkStatusButton: 'Check Status',
        
        // Job Status Display Labels
        statusLabel: 'Status',
        messageLabel: 'Message',
        submittedLabel: 'Submitted',
        updatedLabel: 'Updated',
        uploadedLabel: 'Uploaded',
        processedLabel: 'Processed',
        failedLabel: 'Failed',
        errorsLabel: 'Errors',
        devicesLabel: 'devices',
        completedStatus: 'Completed',
        
        // Error Table Headers
        rowHeader: 'Row',
        errorHeader: 'Error',
        
        // Dialog Action Buttons
        okButton: 'Ok',
        cancelButton: 'Cancel',
        closeButton: 'Close',
        
        // Hardcoded Labels
        bulkUploadExcelMode: 'Bulk Upload (Excel)',
        configurationPageTitle: 'Configuration',
        configurationSubtitle: 'Choose bulk upload or manual update / replace Plug details.',
        configurationSubtitleSearch: 'Search using the MAC ID and update or replace the plug details accordingly.',
        generatingTemplateMessage: 'Generating template...',
        selectExcelFileError: 'Please choose the Excel (.xlsx) file.',
        validatingFileMessage: 'Validating file format and data...',
        uploadingFileMessage: 'Uploading file to server...',
        uploadFailedMessage: 'Failed to upload file to server.',
        networkErrorMessage: 'Network error: Unable to reach the server. Please check your connection.',
        unexpectedErrorMessage: 'An unexpected error occurred during upload.',
        enterDeviceMacError: 'Enter Device Mac ID to load.',
        loadingDeviceMessage: 'Loading device configuration...',
        errorLoadingDevice: 'Error loading device. Please try again.',
        storePlugIdRequired: 'Store Plug ID is required.',
        storeNameRequired: 'Store name is required.',
        locationNameRequired: 'Location name is required.',
        storeIdRequired: 'Store ID is required.',
        locationIdRequired: 'Location ID is required.',
        modelRequired: 'Model is required.',
        replaceDeviceMacRequired: 'Replace Device Mac is required when Device Mac is enabled.',
        updatingDeviceMessage: 'Updating device configuration...',
        creatingDeviceMessage: 'Creating device configuration...',
        saveDeviceFailedMessage: 'Failed to save device configuration.',
        saveFailedPrefix: 'Save failed: ',
        networkErrorSave: 'Network error: Unable to reach the server. Please check your connection.',
        unexpectedSaveError: 'An unexpected error occurred while saving.',
        noValidDataRows: 'No valid data rows found. Please add device data and try again.',
        spDeviceIdEmpty: 'SP Device ID cannot be empty',
        spDeviceIdDuplicated: 'is duplicated in the file',
        spDeviceSSIDEmpty: 'SP Device SSID cannot be empty',
        spDeviceSSIDDuplicated: 'is duplicated in the file',
        foundValidationErrors: 'Found',
        validationErrors: 'validation errors. First 5 errors:',
        validationError: 'validation error',
        validationErrorPlural: 'validation errors:',
        andMoreErrors: 'more errors.',
        fileValidationSuccessful: 'File validation successful. Found',
        validDataRowsText: 'valid data rows with',
        uniqueDevicesText: 'unique devices.',
        failedToCheckJobStatus: 'Failed to check job status',
        deviceMacupdated: 'Device Details Updated Successfully',
        
        // Critical Devices Validation Messages
        criticalDevicesInvalid: 'Single Power Source Devices must be comma-separated values without special characters',
        dualCriticalDevicesInvalid: 'Dual Power Source Devices must be comma-separated values without special characters',
        criticalDevicesTooLong: 'Single Power Source Devices list is too long (maximum 1$ characters)',
        dualCriticalDevicesTooLong: 'Dual Power Source Devices list is too long (maximum 1$ characters)',
        dualCriticalDevicesDisabledForModem: 'Dual Power Source Devices not applicable for Modem devices',
        modemIdDisabledForModem: 'Modem Device ID change not applicable for Modem devices',
        singleCriticalDevicesDisabledForModem: 'Single Power Source Devices not updated for Modem devices, please check respective PDU and update the info',
       
        // Critical Devices Placeholders
        criticalDevicesPlaceholder: 'Enter single power source devices (comma-separated)',
        dualCriticalDevicesPlaceholder: 'Enter dual power source devices (comma-separated)',
        
        // Critical Devices Database Errors
        criticalDevicesDatabaseError: 'Failed to save critical devices data. Please check your input and try again.',
    },
    
    dashboardLabels: {
        // Page Title and Description
        pageTitle: 'Dashboard',
        pageDescription: 'Real-time monitoring and management of ShellyPlug devices',
        
        pageSize: 15,

        // Loading States
        loadingDashboardData: 'Loading dashboard data...',
        loadingSitesAndDevices: 'Loading sites and devices...',
        loadingDevicesOnly: 'Loading devices...',
        loadingEllipsis: '...',
        
        // Device Management Navigation
        deviceManagementInfo: 'To view disabled Shelly Plug details or manage devices, go to',
        deviceManagementLink: 'Device Management',
        deviceManagementClickHere: 'click here',
        
        // Error States
        apiErrorTitle: 'API Error',
        
        // Status Filter Options
        allStatusLabel: 'All Status',
        onlineLabel: 'Online',
        offlineLabel: 'Offline',
        statusFilterLabel: 'Status',
        
        // Status Filters
        allStatus: 'all',
        onlineStatus: 'online',
        offlineStatus: 'offline',
        
        // Hierarchy Navigation
        hierarchyTitle: 'Hierarchy',
        allSites: 'All Sites',
        
        // Device Types
        modemType: 'Modem',
        pduType: 'PDU',
        
        // Actions
        tryAgain: 'Try Again',
        
        // Page Content
        siteHierarchyDescription: 'Site hierarchy and shows device details.',
        siteHierarchyDescriptionAlt: 'Site hierarchy and shows shellyPlug details.',
        
        // KPI Labels
        totalLabel: 'Total',
        onlineKpiLabel: 'Online',
        offlineKpiLabel: 'Offline',
        
        // Real-time Polling
        realTimeOnText: '🔄 Real-time ON ($s)',
        realTimeOffText: '⏸️ Real-time OFF',
        pausedText: '(Paused)',
        
        // Console Log Messages
        expandingSiteLog: 'Expanding site:',
        devicesApiResponseLog: 'Devices API Response:',
        noDevicesDataWarning: 'No devices data in response',
        
        // Status Values
        onlineStatusValue: 'online',
        offlineStatusValue: 'offline',
        
        // Error Messages
        errorFetchingSites: 'Error fetching sites:',
        errorFetchingDevices: 'Error fetching devices:',
        errorDuringRefresh: 'Error during refresh:',
        errorInFetchAllData: 'Error in fetchAllData:',
        errorDuringRealTimePolling: 'Error during real-time polling:'
    },
    
    dashboardTableLabels: {
        // Error Messages
        errorLoadingDevices: 'Error Loading Devices',
        noDevicesFoundMessage: 'No devices found',
        tryDifferentSelection: 'Try selecting a different site or location to view devices.',
        refreshPageMessage: 'Please try refreshing the page or selecting a different site/location.',
        
        // Table Headers
        plugIdHeader: 'Plug ID',
        siteHeader: 'Site',
        locationHeader: 'Location',
        deviceName: 'Device',
        deviceMacHeader: 'Mac ID',
        statusHeader: 'Status',
        modelHeader: 'Model',
        deviceTypeHeader: 'Plug',
        modemIdHeader: 'Modem ID',
        criticalDevicesHeader: 'Critical Devices',
        lastHeartbeatHeader: 'Last Heartbeat',
        
        // Device Types
        modemType: 'Modem',
        pduType: 'PDU',
        
        // Pagination
        paginationActive: 'active',
        
        // Refresh Status
        lastRefreshedPrefix: 'Last refreshed: ',
        autoRefreshPaused: ' (Auto-refresh paused)',
        autoRefreshActive: ' (Auto-refresh: 40s)',
        
        // Actions
        refreshButton: 'Refresh',
        autoRefreshValue: 40,
        autoRefreshLabelInTable: '(Auto-refresh: $s)'
    },
    
    plugDrawerLabels: {
        // Drawer Title
        drawerTitle: 'Device Details',
        
        // Tab Names
        alertsTab: 'alerts',
        logsTab: 'logs',
        
        // Sort Directions
        ascSort: 'asc',
        descSort: 'desc',
        
        // Date Range Validation
        dateRangeError: 'Date range cannot exceed 30 days',
        fromDateAfterToDate: 'From Date cannot be after To Date',
        
        // API Parameters
        defaultPageSize: 500,
        defaultSortByLogs: 'last_updated_at',
        defaultSortByAlerts: 'reported_time',
        defaultSortOrder: 'desc',
        
        // Table Headers
        timestampHeader: 'Timestamp',
        messageHeader: 'Message',
        severityHeader: 'Severity',
        reportedTimeHeader: 'Reported Time',
        incidentTypeHeader: 'Incident Type',
        descriptionHeader: 'Description',
        
        // Loading States
        loadingLogs: 'Loading logs...',
        loadingAlerts: 'Loading alerts...',
        
        // Empty States
        noLogsFound: 'No logs found',
        noAlertsFound: 'No alerts found',
        
        // Error States
        errorLoadingLogs: 'Error loading logs',
        errorLoadingAlerts: 'Error loading alerts',
        
        // Actions
        searchButton: 'Search',
        refreshLogsButton: 'Refresh Logs',
        refreshAlertsButton: 'Refresh Alerts',
        retryButton: 'Retry',
        closeDrawer: 'Close',
        
        // Date Labels
        fromDateLabel: 'From Date',
        toDateLabel: 'To Date',
        
        // Pagination
        showingText: 'Showing',
        ofText: 'of',
        
        // Drawer Header
        detailsAndHeartbeats: 'Details & Alerts :',
        
        // Error Messages
        deviceDetailsError: 'Device Details Error',
        failedToLoadCompleteDetails: 'Failed to load complete device details',
        showingBasicInfoFromCache: 'Showing basic information from cache. Some details may be missing or outdated.',
        
        // Device Details Labels
        plugIdLabel: 'Plug ID',
        siteLabel: 'Site',
        locationLabel: 'Location',
        deviceMacLabel: 'Device Mac ID',
        statusLabel: 'Status',
        modelLabel: 'Model',
        smartPlugLocationLabel: 'Smart Plug Location',
        modemIdLabel: 'Modem ID',
        singleSourceDevicesLabel: 'Single Power Source Devices',
        dualSourceDevicesDeviceLabel: 'Dual Power Source Devices',
        lastHeartbeatLabel: 'Last Heartbeat',
        deviceNameLabel: 'Device Name',

        // Device Types
        modemType: 'Modem',
        pduType: 'PDU',
        
        // Section Headers
        deviceLogsHeader: 'Device Logs',
        deviceAlertsHeader: 'Device Alerts',
        
        // Loading States
        loadingDotsText: 'Loading...',
        loadingAlertsText: 'Loading alerts...',
        
        // Advanced Search
        advancedSearchToggle: 'Advanced Search',
        fromDateTimeLabel: 'From Date & Time',
        toDateTimeLabel: 'To Date & Time',
        rangePrefix: 'Range: ',
        rangeArrow: ' → ',
        
        // Alerts Section
        refreshAlertsButtonDynamic: 'Refresh Alerts',
        errorLoadingAlertsPrefix: 'Error loading alerts: ',
        noAlertsAvailable: 'No alerts available for this device',
        
        // Table Headers - Alerts
        incidentIdHeader: 'Incident ID',
        alertTypeHeader: 'Alert Type',
        reportedTimeHeaderAlt: 'Reported Time',
        descriptionHeaderAlt: 'Description',
        
        // Pagination
        previousButton: 'Previous',
        nextButton: 'Next',
        pagePrefix: 'Page ',
        pageOfSeparator: ' of ',
        
        // Console Log Messages
        logsApiResponse: 'Logs API Response:',
        alertsApiResponse: 'Alerts API Response:',
        logsSortTriggered: 'Logs sort triggered - Field:',
        directionLabel: 'Direction:',
        currentLogsDataSample: 'Current logs data sample:',
        sortingAlertsBy: 'Sorting alerts by:',
        sampleAlertData: 'Sample alert data:',
        applyingLogsSort: 'Applying logs sort - Field:',
        applyingSort: 'Applying sort - Field:',
        originalFirstItem: 'Original first item:',
        sortedFirstItem: 'Sorted first item:',
        errorSearchingWithDateRange: 'Error searching with date range:'
    },

    deviceTroubleLabels: {
        // Page Title and Description
        pageTitle: 'Device Troubleshooting',
        pageDescription: 'Diagnostic connectivity testing. Search for a device to begin troubleshooting.',
        
        // Search and Results
        searchPlaceholder: 'Search by Device MAC ID',
        searchButton: 'Search Device',
        searchResults: 'Search Results',
        deviceFound: 'Device Found',
        devicesFound: 'Devices Found',
        noDevicesFound: 'No devices matched your search.',
        
        // Loading States
        loadingDevice: 'Loading device details...',
        searchingDevice: 'Searching for device...',
        
        // Error States
        errorLoadingDevice: 'Error Loading Device',
        deviceNotFound: 'Device not found',
        apiError: 'API Error',
        invalidMacAddress: 'Please enter a valid MAC address',
        
        // Table Headers
        deviceMacHeader: 'MAC ID',
        deviceNameHeader: 'Name',
        siteHeader: 'Site',
        locationHeader: 'Location',
        criticalDevices: 'Critical Devices',
        statusHeader: 'Status',
        actionItems: 'Actions',
        history: 'History',
        modelHeader: 'Model',
        lastHeartbeatHeader: 'Last Heartbeat',
        actionHeader: 'Action',
        
        // Console
        consoleTitle: 'DIAGNOSTIC CONSOLE',
        clearLogs: 'Clear Logs',
        systemStatus: 'SYSTEM STATUS:',
        statusNominal: 'NOMINAL',
        networkConnected: 'NETWORK APP CONNECTED',
        awaitingCommand: 'Awaiting diagnostic command…',
        
        // Diagnostic Actions
        pingButton: 'Reboot',
        pingingStatus: 'Rebooting...',
        diagnosticTitle: 'Network Diagnostics',
        searching: 'Searching...',
        
        // Action Icons
        turnOnButton: 'Turn On',
        turnOffButton: 'Turn Off',
        restartButton: 'Restart',
        historyButton: 'View History',
        turningOn: 'Turning On...',
        turningOff: 'Turning Off...',
        restarting: 'Restarting...',
        
        // History Panel
        historyPanelTitle: 'Device History',
        closeHistory: 'Close History',
        noHistoryData: 'No history data available for this device.',
        historyDate: 'Date',
        historyTriggeredBy: 'Triggered By',
        historyComments: 'Comments',
        historyAction: 'Action',
        historyStatus: 'Status',
        loadingHistory: 'Loading device history...',
        errorLoadingHistory: 'Error loading device history',
        
        // Messages
        tryDifferentSearch: 'Try searching with a different MAC address.',
        refreshPageMessage: 'Please try refreshing the page or check your network connection.',
        DEFAULT_ROWS_PER_PAGE: 10
    },

    deviceManagementLabels: {
        // Page Title and Description
        pageTitle: 'Device Management',
        pageDescription: 'Search and manage device status, enable or disable devices as needed',
        
        // Dialog Labels
        confirmDialogTitle: 'Confirm Device Status Change',
        actionSelectionLabel: 'Select Comments',
        actionSelectionPlaceholder: 'Choose a comment to perform device status change',
        
        // Comment Options - Based on Status (for backend API calls)
        actionOptions: {
            // Available comments for currently enabled devices
            enabled: [
                 'Activate device and resume operations',
            ],
            // Available comments for currently disabled devices
            disabled: [
              'Schedule device for maintenance operations',
              'Temporarily disable the device operations'
            ],
            // Fallback comments for devices with unknown status
            default: [
                'Schedule device for maintenance operations' ,
                'Temporarily disable device operations',
                'Activate device and resume operations',
            ]
        },
        
        // Button Labels
        confirmButton: 'Confirm Action',
        cancelButton: 'Cancel',
        processingButton: 'Processing...',
        
        // Messages
        selectActionMessage: 'Please choose a comment to perform on this device.',
        actionConfirmationMessage: 'Are you sure you want to perform this device status change?',
        deviceMacLabel: 'Device MAC:',
        selectedActionLabel: 'Selected Comments:',
        
        // Error Messages
        noActionSelected: 'Please select an action before proceeding.',
        actionFailed: 'Failed to perform the selected action. Please try again.',
        
        // Search and Table Labels
        searchPlaceholder: 'Search by Device Name or MAC Address...',
        searchResultsTitle: 'Search Results',
        copyDeviceMacTooltip: 'Copy Device MAC',
        clearSearchTooltip: 'Clear search',
        refreshDisabledDevicesTooltip: 'Refresh disabled devices list',
        noDevicesFound: 'No devices found matching',
        noDisabledDevicesFound: 'No disabled devices found',
        noDeviceFoundWithMac: 'No device found with the specified MAC address',
        loadingDeviceHistory: 'Loading device history...',
        refreshHistory: 'Refresh History',
        refreshingHistory: 'Refreshing...',
        deviceHistoryError: 'Error loading device history:',
        deviceDetailsTitle: 'Device Details :',
        disabledDevicesTitle: 'Viewing Disabled Devices Across All Sites',
        
        // Table Headers
        deviceNameHeader: 'Device Name',
        deviceMacHeader: 'Mac ID',
        siteHeader: 'Site',
        locationHeader: 'Location',
        statusHeader: 'Status',
        smartPlugLocationHeader: 'Plug',
        criticalDevicesHeader: 'Critical Devices',
        disableEnableHeader: 'Disable/Enable',
        dateHeader: 'Date',
        actionHeader: 'Disable/Enable',
        commentHeader: 'Comment',
        triggeredByHeader: 'Triggered By',
        
        // Device History
        deviceHistoryTitle: 'Device History',
        noDeviceHistoryAvailable: 'No device history available'
    }
};
// UI Configuration Constants with responsive breakpoints
const getResponsiveUIConfig = () => {
  const screenWidth = window.innerWidth;
  
  // Define breakpoints
  const breakpoints = {
    mobile: 768,
    tablet: 1024,
    desktop: 1440,
    largeDesktop: 1920
  };
  
  // Calculate responsive values based on screen width
  let columnLimits, truncatedLimits;
  
  if (screenWidth < breakpoints.mobile) {
    // Mobile screens - shorter text limits
    columnLimits = {
      siteId: 8,
      locationId: 8,
      criticalDeviceList: 10, // Increased for better display
      deviceName: 8,
    };
    truncatedLimits = {
      siteId: 5,
      locationId: 5,
      criticalDeviceList: 8, // Increased for uniform appearance
      deviceName: 5
    };
  } else if (screenWidth < breakpoints.tablet) {
    // Tablet screens - medium text limits
    columnLimits = {
      siteId: 12,
      locationId: 12,
      criticalDeviceList: 14, // Increased for better display
      deviceName: 12
    };
    truncatedLimits = {
      siteId: 8,
      locationId: 8,
      criticalDeviceList: 10, // Increased for uniform appearance
      deviceName: 8
    };
  } else if (screenWidth < breakpoints.desktop) {
    // Small desktop screens - default values
    columnLimits = {
      siteId: 15,
      locationId: 15,
      criticalDeviceList: 18, // Increased for better display
      deviceName: 15
    };
    truncatedLimits = {
      siteId: 10,
      locationId: 10,
      criticalDeviceList: 12, // Increased for uniform appearance
      deviceName: 10
    };
  } else if (screenWidth < breakpoints.largeDesktop) {
    // Large desktop screens - increased limits
    columnLimits = {
      siteId: 20,
      locationId: 20,
      criticalDeviceList: 22, // Increased for better display
      deviceName: 20
    };
    truncatedLimits = {
      siteId: 15,
      locationId: 15,
      criticalDeviceList: 18, // Increased for uniform appearance
      deviceName: 15
    };
  } else {
    // Extra large screens - maximum limits
    columnLimits = {
      siteId: 25,
      locationId: 25,
      criticalDeviceList: 27, // Increased for better display
      deviceName: 25
    };
    truncatedLimits = {
      siteId: 20,
      locationId: 20,
      criticalDeviceList: 22, // Increased for uniform appearance
      deviceName: 20
    };
  }
  
  return {
    columnTextLimits: columnLimits,
    truncatedTextLimits: truncatedLimits,
    tooltipSettings: {
      maxWidth: screenWidth < breakpoints.mobile ? '120px' : '200px',
      iconColor: '#4f7cff',
      iconSize: screenWidth < breakpoints.mobile ? '12px' : '16px'
    }
  };
};

// Export responsive UIConfig
export const UIConfig = getResponsiveUIConfig();
